exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-staff-title[data-v-77be93bd]{color:#303030;font-family:Open Sans,sans-serif;font-size:14px;font-weight:600;letter-spacing:0;line-height:22px}.admin-staff-subtitle[data-v-77be93bd]{color:#7d8fa6;font-family:\\.SF NS Display,sans-serif;font-size:10px;letter-spacing:0;line-height:22px}.admin-staff-time[data-v-77be93bd]{color:#808fa4;font-family:Open Sans,sans-serif;font-size:14px;font-weight:600;letter-spacing:0;line-height:22px}.admin-staff-time .cost-due[data-v-77be93bd]{display:inline;font-weight:700;color:#0b1324}", ""]);

// exports
